export const filterPrices = [
	{ text: 'Below ₹ 50k', route: 'below50' },
	{ text: 'Below ₹ 75k', route: 'below75' },
	{ text: 'Below ₹ 1L', route: 'below1L' },
	{ text: 'Above ₹ 1L', route: 'above1L' },
]

export const faqSectionArr = [
	{
		text: 'How do I get to my Resort?',
		bgPosition: '-410px -56px',
	},
	{
		text: 'What’s the difference between split stay and single stay?',
		bgPosition: '-488px -56px',
	},
	{
		text: 'What’s the best time to visit Maldives?',
		bgPosition: '-410px 0',
	},
	{
		text: 'What is a Green Tax?',
		bgPosition: '-488px 0',
	},
	{
		text: 'Which SIM card is best suitable for Maldives travel?',
		bgPosition: '-410px -56px',
	},
	{
		text: 'Can I carry Alcohol?',
		bgPosition: '-488px -56px',
	},
]
